module.exports = __webpack_public_path__ + "fonts/bdd103172a825b261bf1b8e6b588261b.svg";